import { render, staticRenderFns } from "./RentalCarEdit.vue?vue&type=template&id=64baf55d&scoped=true"
import script from "./RentalCarEdit.vue?vue&type=script&lang=js"
export * from "./RentalCarEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64baf55d",
  null
  
)

export default component.exports